import {getAPIGatewayDataFromParent, getCycleDataFromParent} from "../../handler/ParentDataHandler";
import {getStationCode} from "../../network/NetworkUtil";
import {logOperationalMetric} from "../../util/Util";

const metricProcessName = "SCC_RECEIVE";
/**
 * API Call to fetch lineHaul List
 * @param dispatcher
 */
export function fetchLineHaulList(groupBy, dispatcher) {
    getLineHaulList(groupBy, dispatcher);
}

function getLineHaulListAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getNodeLineHaulList",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getLineHaulList(groupBy, dispatcher) {
    const request = {
        nodeId: getStationCode(),
        groupBy: groupBy
    }
    const args = getLineHaulListAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulList", true);
            const lineHaulList = {
                arrived: [],
                inComing: []
            };
            let output = result.data.lineHauls;
            output.forEach(lineHaul => {
                if (lineHaul.lineHaulStatus === "ARRIVED") {
                    lineHaul.lineHaulStatus = "Arrived";
                    lineHaulList.arrived.push(lineHaul);
                } else {
                    lineHaul.lineHaulStatus = (lineHaul.lineHaulStatus === 'IN_TRANSIT') ? "In-Transit" : "Pending Depart";
                    lineHaulList.inComing.push(lineHaul);
                }
                lineHaulList.arrived.sort((a, b) => {
                    return new Date(getRelevantDate(a)) - new Date(getRelevantDate(b))
                })
                lineHaulList.inComing.sort((a, b) => {
                    return new Date(getRelevantDate(a)) - new Date(getRelevantDate(b))
                })
            });
            dispatcher({type: "RECEIVE_DATA", data: lineHaulList});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getLineHaulList", false);
            dispatcher({type: "RECEIVE_DATA", data: {
                    arrived: [],
                    inComing: []
                }});
        }
    });
}

function getRelevantDate(lineHaul) {
    return lineHaul.lineHaulTime.actualTime ? lineHaul.lineHaulTime.actualTime
        : lineHaul.lineHaulTime.gpsTime ? lineHaul.lineHaulTime.gpsTime
            : lineHaul.lineHaulTime.plannedTime;
}

export function fetchCycleFilter(dispatcher) {
    getCycleFilterValues(dispatcher);
}

export function fetchCPTFilter(dispatcher) {
    getCPTFilterValues(dispatcher);
}

/**
 * API Call to fetch Filter
 * @param lineHaulId
 * @param dispatcher
 */

export function fetchFilterValues(dispatcher) {
    getFilterValues(dispatcher);
}

function getFilterAPIGatewayRequest(requestParams) {
    return {
        resourcePath: '/ivs/getFilters',
        httpMethod: "get",
        processName: "induct",
        requestParams: requestParams
    }
}

async function getFilterValues(dispatcher) {
    const requestParams = {
        nodeId: [getStationCode()]
    };
    const args = getFilterAPIGatewayRequest(requestParams);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getReceiveInductFilters", true);
            dispatcher({type: "RECEIVE_FILTER_FOR_LINEHAUL", data: result.data.filterMap});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getReceiveInductFilters", false);
        }
    });
}

async function getCycleFilterValues(dispatcher) {
    getCycleDataFromParent().then(cycleData => {
        let data = JSON.parse(cycleData.cycleList).filter(cycle => {
            return cycle.cycleId !== 'AllCycles'
        });
        const NoCycle = {
            casCycleId: null,
            cycleId: "NONE",
            cycleName: "NONE"
        }
        data = [...data, NoCycle]
        dispatcher({type: "RECEIVE_CYCLE", data: data})
    });
}

function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getStationCPTs",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

export function getCPTFilterValues(dispatcher) {

    const request = {
        nodeId: getStationCode(),
    }
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            let data= JSON.parse(output.CPTList).filter(CPT => CPT.label !== 'ALL')
            const unplanned = {
                id: "NONE",
                label: "NONE"
            }
            data = [...data, unplanned]
            dispatcher({type: "RECEIVE_CPT", data: data})
            dispatcher({type: "ASSIGN_LABEL", data: {CPTLabel: output.CPTTypeLabelKey}})
            dispatcher({type: "ASSIGN_FILTER_IDENTIFIER", data: {filterIdentifier: output.filterIdentifier}})
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });
}

/**
 * API call to fetch Line Haul Container detail
 * @param lineHaulId
 * @param filter
 * @param dispatcher
 */
export function fetchContainerDetail(lineHaulId, filter, dispatcher, isCPTFilterEnabled) {
    if (lineHaulId && lineHaulId.length > 0) {
        let filterMap;
        if(isCPTFilterEnabled){
            filterMap = {
                [filter.filterIdentifier]: filter.Filters.CPT.filter(CPTDetail => filter.CPT.includes(CPTDetail.label))
                    .map(CPTDetail => CPTDetail.id),
                "EAD": filter.EAD,
                "OtherAttributes": filter.OtherAttributes,
                "Cluster": filter.Cluster,
                "PackageSize": filter.PackageSize,
                "StationCode": filter.StationCode
            };
        }
        else{
            filterMap = {
                "Cycle": filter.Cycle,
                "EAD": filter.EAD,
                "OtherAttributes": filter.OtherAttributes,
                "Cluster": filter.Cluster,
                "PackageSize": filter.PackageSize,
                "StationCode": filter.StationCode
            };
        }
        const request = {
            nodeId: getStationCode(),
            lineHaulId: [lineHaulId],
            filters: filterMap
        };
        getContainerDetail(dispatcher, request);
    }
}

function getContainerDetailAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getLineHaulContainerDetail",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getContainerDetail(dispatcher, request) {
    const args = getContainerDetailAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerDetailForLineHaul", true);
            let output = result.data.lineHaulsContainerDetail;
            dispatcher({type: "RECEIVE_DATA", data: {
                 details: (output) ? output[request.lineHaulId].sort((a, b) =>
                     a.containerId.toLowerCase() > b.containerId.toLowerCase() ? 1 : -1) : []
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerDetailForLineHaul", false);
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/linehaul/network/LineHaulNetworkAPI.js